if (!customElements.get('zz-trial-progress')) {
    class ZZTrialProgress extends HTMLElement {
      constructor() {
        super();
        // this.trialTime = 15 * 24 * 60 * 60 * 1000;
        // this.decisionTime = 24 * 60 * 60 * 1000;
        // this.overdueTime = 48 * 60 * 60 * 1000;
        this.timer = null;
        this.timeoutTime = 0;
        this.baseUrl = 'https://h130-app-server-us.hoverx1.cn'
        
      }
    
      connectedCallback() {
        this.initEvent();

        if (document.documentElement.classList.contains('shopify-design-mode')) {
          console.log("在主题编辑器里");
          return;
        }
        this.getOrderRequest();
        
  

      }
      initEvent() {
        this.userId = this.getAttribute('data-user-id');
        this.trilTitleEl = this.querySelector('.trial-title');
        this.trialTimeEl = this.querySelector('.remaining-trial-time');
        this.trialDescEl = this.querySelector('.trial-desc');
        this.trialNumberEl = this.querySelector('.trial-number');
        this.trialTrackingNumberEl = this.querySelector('#trial-tracking-number');
        this.buttonBoxEl = this.querySelector('.return-keep-div');

        // 处理退回事件
        const returnBtn = this.querySelector('.return-btn');
        returnBtn && returnBtn.addEventListener('click', () => {
          const returnModal = document.querySelector('zz-trial-return-modal');
          if(returnModal) {
            returnModal.showModal();
          }
        });
      }

      getOrderRequest() {
        // 1、判断是否有正在进行的试用订单
        // 2、如果有，则获取订单信息
        // 15d +24h +48h
        // 2.1 判断订单状态 , 已退货-去退货页面(退回过程中，退回完成)、已支付尾款-去完成完成， 试用中（待收货，倒计时中（15天内）， 超时7天内， ）、超时7天后锁定机器-去overy页面， 

        httpRequest
        .get(
          '/shopify/trial/snapshot',
          {
            userId: this.userId,
          },
          { baseUrl: this.baseUrl }
        )
        .then((res) => {
          if (res.code === 200) {
            const order = res.data;
            if(!order.existTrialOrder) {
              // 没有试用订单，去购买页面
              window.location.replace('/pages/trial-start');
              return;
            } 
            window.zzTrialPageData = order;
            // const order = {
            //   nextSnapshotInterval: 48, 
            //   snapshotPoint: "overdue",            
            //   snapshotTriggerTime: 1758685592191,  
            //   trackingNumber: 'LT123456789CN',
    
            // }
            this.handleStatusPage(order.snapshotPoint); // todo 测试环境查看
            this.timeoutTime = order.nextSnapshotInterval * 60 * 60 * 1000;
            switch(order.snapshotPoint) {
              case 'pending':
              case 'paid':
                {
                  this.trilTitleEl.innerHTML = this.getAttribute('data-waiting-title');
                  const daysLeft = Math.ceil(order.nextSnapshotInterval / 24);
                  this.trialTimeEl.innerHTML = `${daysLeft} days left`
                  this.trialTimeEl.classList.add('trial-time-waiting');
                  this.buttonBoxEl.classList.add('tw-hidden');
                  this.trialDescEl.classList.add('tw-hidden');
                  const hiddenPriceEl = document.querySelector('#zz-trial-price-hidden-pending');
                  if(hiddenPriceEl) {
                    hiddenPriceEl.classList.add('!tw-hidden');
                  }
                  
                  if(order.trackingNumber) {
                    this.trialNumberEl.classList.remove('tw-hidden');
                    this.trialTrackingNumberEl.innerHTML = order.trackingNumber;
                  }
                  const pendingHiddenReturnIt = document.querySelector('.pending-hiden-return-it');
                  if(pendingHiddenReturnIt) {
                    pendingHiddenReturnIt.classList.add('!tw-hidden');
                  }
                }
                break;
              case 'in_trial':
                {
                  this.trilTitleEl.innerHTML = this.getAttribute('data-in-trial-title');
                  this.trialDescEl.classList.add('tw-hidden');
                  this.trialNumberEl.classList.add('tw-hidden');
                  this.handleTrialTime(order.snapshotTriggerTime);
                  const pendingHiddenReturnIt = document.querySelector('.pending-hiden-return-it');
                  if(pendingHiddenReturnIt) {
                    pendingHiddenReturnIt.classList.remove('tw-hidden');
                  }
                }
                break;
              case 'decision':
                {
                  this.trilTitleEl.innerHTML = this.getAttribute('data-decision-time-title');
                  this.trialDescEl.classList.add('tw-hidden');
                  this.trialNumberEl.classList.add('tw-hidden');
                  this.handleDecisionTime(order.snapshotTriggerTime);
                }
                break;
              case 'decision_period_expired':
                {
                  this.trilTitleEl.innerHTML = this.getAttribute('data-expired-title');
                  this.trialDescEl.classList.remove('tw-hidden');
                  this.trialNumberEl.classList.add('tw-hidden');
                  this.trialTimeEl.classList.add('expired-title');
                  this.handleDecisionxpiredTime(order.snapshotTriggerTime);
                }
                break;
              case 'return_in_progress':
                {
                  const processEl = this.querySelector('.trial-return-progress');
                  const completedEl = this.querySelector('.trial-return-completed');
                  processEl && processEl.classList.remove('tw-hidden');
                  completedEl && completedEl.classList.add('tw-hidden');
                }
                break;
              case 'return_completed':
                {
                  const processEl = this.querySelector('.trial-return-progress');
                  const completedEl = this.querySelector('.trial-return-completed');
                  processEl && processEl.classList.add('tw-hidden');
                  completedEl && completedEl.classList.remove('tw-hidden');
                }
                break;
              case 'overdue':
                {
                  // this.trialTimeEl.classList.remove('tw-hidden');
                  // this.trialTimeEl.innerHTML = `${order.nextSnapshotInterval}h`;
                }
                break;
            }
          }
        }).catch((error) => {
          // 请求失败，跳转到首页
          window.location.replace('/');
        });


        
       
        
      }

      handleStatusPage(status) {
        // 不同的状态去不同的路由，如何与当前路由相同则不处理，不相同则跳转
        const statusPage = {
          'paid': '/pages/in-trial',
          'pending': '/pages/in-trial',
          'in_trial': '/pages/in-trial',
          'decision': '/pages/in-trial',
          'decision_period_expired': '/pages/in-trial',
          'return_in_progress': '/pages/trial-return',
          'return_completed': '/pages/trial-return',
          'purchase_completed': '/pages/trial-purchase',
          'overdue': '/pages/trial-overdue',
        }
        const currentPath = window.location.pathname;
        const toPath = statusPage[status];
        console.log('handleStatusPage', currentPath, toPath);
        if(!toPath) {
          return;
        }
        if(toPath == currentPath) {
          return;
        } else {
          window.location.replace(toPath);
        }

      }

 
      handleTrialTime(pointTime) {
        
        this.timer && clearInterval(this.timer);
        // time 时间格式 1758294082000
        const countdownTime = () => {
          const now = Date.now();
          const timeDiff = this.timeoutTime - (now - pointTime);
          let showTimeText = ''
          if (timeDiff < 24 * 60 * 60 * 1000) {
            // 最后一天返回倒计时，时分秒，格式： "23h59min12s", 其他时间返回还剩下几天 格式 "x days left"
            if(timeDiff < 0) {
              this.timer && clearInterval(this.timer);
              // 重新请求接口获取状态
              setTimeout(() => {
                this.getOrderRequest();
              }, 1500);
            } else {
              showTimeText = this.computeDhms(timeDiff);
            }
          } else {
            const daysLeft = Math.ceil(timeDiff / (24 * 60 * 60 * 1000));
            showTimeText = `${daysLeft} days left`;
            this.timer && clearInterval(this.timer);
          }
          console.log('showTimeText', showTimeText)
          this.trialTimeEl.innerHTML = showTimeText;
        }
        countdownTime();
        this.timer = setInterval(countdownTime, 1000)
        
      }
      handleDecisionTime(pointTime) {
         // 决策时间， 到货时间time 与现在时间now 对比， 
         this.timer && clearInterval(this.timer);
        const countdownTime = () => {
          const decisionTime = Date.now() - pointTime;
            let showTimeText = ''
            const timeDiff = this.timeoutTime - decisionTime;
            if (timeDiff > 0) {
              showTimeText = this.computeDhms(timeDiff);
            } else {
              this.timer && clearInterval(this.timer);
              this.getOrderRequest();
            }
            this.trialTimeEl.innerHTML = showTimeText;
        }
        countdownTime();
        this.timer = setInterval(countdownTime,1000)
          
      }
      handleDecisionxpiredTime(pointTime) {
        this.timer && clearInterval(this.timer);
        const countdownTime = () => {
          const now = Date.now();
          const timeDiff = now - pointTime;
          let showTimeText = ''
          if(timeDiff < 0) {
            this.timer && clearInterval(this.timer);
            this.getOrderRequest();
          } else if (timeDiff > this.timeoutTime) {
            this.timer && clearInterval(this.timer);
            this.getOrderRequest();
          } else {
            showTimeText = this.computeDhms(timeDiff);
          }
          this.trialTimeEl.innerHTML = showTimeText;
        }

        countdownTime();
        this.timer = setInterval(countdownTime,1000)
      }

      computeDhms(timeDiff) {
        const hours = Math.floor((timeDiff % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
        const minutes = Math.floor((timeDiff % (60 * 60 * 1000)) / (60 * 1000));
        const seconds = Math.floor((timeDiff % (60 * 1000)) / 1000);
        return `${hours}h${minutes}min${seconds}s`;
      }
     
    
    
    }
  
    customElements.define('zz-trial-progress', ZZTrialProgress);
  }
  






  if (!customElements.get('zz-trial-return-modal')) {
    class ZZTrialReturnModal extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
    
      init() {
        const closeBtn = this.querySelector('#close-modal-btn');
        closeBtn.addEventListener('click', () => {
          this.closeModal();
        });

        const cancelBtn = this.querySelector('.modal-cancel-btn');
        cancelBtn.addEventListener('click', () => {
          this.closeModal();
        });

        const returnBtn = this.querySelector('.modal-return-btn');
        returnBtn.addEventListener('click', () => {
          if(window.zzTrialPageData) {
            const { snapshotTriggerTime } = window.zzTrialPageData;
            const now = Date.now();
            const duration = Math.floor((now - snapshotTriggerTime) / (1000 * 60 * 60));
            window.zzAnalytics && window.zzAnalytics.trackEvent('trial_return_click', {
              duration,
            });
          }
        });
  

      }
      showModal() {

        const modal = this.querySelector('#zz-trial-return-modal');
        const mask = this.querySelector('#zz-trial-return-modal-mask');
        const body = document.body;
        modal.style.display = 'block';
        mask.style.display = 'block';
        setTimeout(() => {
          modal.classList.add('show');
        }, 10);
        body.classList.add('modal-open');
    
      }
      closeModal() {
        const modal = this.querySelector('#zz-trial-return-modal');
        const mask = this.querySelector('#zz-trial-return-modal-mask');
        const body = document.body;
        modal.classList.remove('show');
        body.classList.remove('modal-open');
  
        modal.style.display = 'none';
        mask.style.display = 'none';
   
        
      }
     
    
    
    }
  
    customElements.define('zz-trial-return-modal', ZZTrialReturnModal);
  }
